<template>
    <settings-page
        v-slot="{ formProcessing, onSubmit }"
        :show="show"
        class="show-settings-branding"
    >
        <branding
            :show="show"
            :form-processing="formProcessing"
            @submit="onSubmit"
        />
    </settings-page>
</template>
<script>
import Branding from '@/components/Shows/Settings/Branding';
import SettingsPage from './SettingsPage';

export default {
    components: {
        Branding,
        SettingsPage,
    },

    props: {
        show: {
            type: [Object, Boolean],
            default: () => ({}),
        },
        playerEmbed: {
            type: [Boolean, Object],
            default: false,
        },
    },
};
</script>
